// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"0fba584c","583":"53c447c9","845":"6b714e7c","983":"583d9a46"}[chunkId] + ".chunk.js";
};